
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Media,
  Button,
} from "reactstrap"

import { AvForm, AvField } from "availity-reactstrap-validation"
import { useSelector, useDispatch } from "react-redux"
import { withRouter } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
import avatar2 from "../../assets/images/users/24X7RETAIL.png"
import { GetAllUserData, UpdatePersonalDetails, UpdatePersonalPassword } from "pages/Utility/User-Master/UserMasterController"
import { Context } from '../../app-contexts/CommonContexts';
import { useContext } from "react"
import { Text } from "framework/validators/TextValidation"
import DPTextBox from "framework/components/DPTextBox"

const UserProfile = props => {

  const {
    getMenuDetails, passwordpolicy, passwordPolicyDescription, addtoFavourite, mobileNumberRegexp, emailRegexp, fetchAutoCode, masterAuditLog, getSelectedMasterPermissions
  } = useContext(Context);


  const [error, seterror] = useState(null)
  const [success, setsuccess] = useState(null)

  const [username, setusername] = useState("")
  const [location, setlocation] = useState("")
  const [company, setcompany] = useState("")
  const [usrImg, setusrImg] = useState(avatar2);
  const [isUserImage, setIsUserImage] = useState(true)


  var password_pattern = new RegExp(passwordpolicy)

  const [personalDetails, setPersonalDetails] = useState({
    firstName: "",
    lastName: "",
    fullName: "",
    allowEdit: false,
  })


  const [passwordDetails, setPasswordDetails] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  })

  const textValidations = {
    currentPassword: e => Text(e.target, 12, true, true, 'any', false),
    newPassword: e => Text(e.target, 12, true, true, 'any', false),
    confirmPassword: e => Text(e.target, 12, true, true, "any", false),
    firstName: e => Text(e.target, 50, true, false, 'any', true),
    lastName: e => Text(e.target, 50, true, false, 'any', true),
    fullName: e => Text(e.target, 200, true, false, 'any', true),
  }


  useEffect(async () => {
    if (localStorage.getItem("authUser")) {

      const obj = JSON.parse(localStorage.getItem("authUser"))
      setusername(obj[0])
      setlocation(obj[4])
      setcompany(obj[6])

      setusrImg(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`)
      try {
        const response = await fetch(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`);
        if (!response.ok) {
          setIsUserImage(false)
        }
      } catch (error) {
        console.log(error)
      }

      GetUserData()
    }
  }, [localStorage.getItem("Serial")])

  async function handleValidSubmit() {

    if (personalDetails.firstName === "" || personalDetails.lastName === "" || personalDetails.fullName === "") {
      //set error
      seterror("Please fill all the fields")
      setTimeout(() => {
        seterror(null)
      }, 5000);
      return
    }

    let saveObj = {
      FirstName: personalDetails.firstName,
      LastName: personalDetails.lastName,
      FullName: personalDetails.fullName,
      UserID: JSON.parse(localStorage.getItem("authUser"))[2]
    }

    const saveResponse = await UpdatePersonalDetails(saveObj)
    if (saveResponse.isSuccess) {
      setsuccess(saveResponse.data)
      setTimeout(() => {
        setsuccess(null)
      }, 5000);
      GetUserData()
    } else {
      seterror(saveResponse.data)
      setTimeout(() => {
        seterror(null)
      }, 5000);
    }

  }

  function personalDetailsOnChange(e) {
    const { name, value } = e.target
    const validated = textValidations[name](e)
    setPersonalDetails({ ...personalDetails, [name]: validated })
  }

  function passwordDetailsOnChange(e) {
    const { name, value } = e.target
    const validated = Text(e.target, 12, true, true, "any", false)
    setPasswordDetails({ ...passwordDetails, [name]: validated })
  }


  async function GetUserData() {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    const { isSuccess, data, error } = await GetAllUserData(obj[2])
    if (isSuccess) {
      setPersonalDetails({
        firstName: data.strUserFname,
        lastName: data.strUserLName,
        fullName: data.strUserFullName,
        allowEdit: false
      })
    }
  }

  async function handleUpdatePassword() {

    if (passwordDetails.currentPassword == "") {
      seterror("Please enter current password")
      setTimeout(() => {
        seterror(null)
      }, 5000);
      return
    }

    if (passwordDetails.newPassword == "") {
      seterror("Please enter new password")
      setTimeout(() => {
        seterror(null)
      }, 5000);
      return
    }

    if (passwordDetails.confirmPassword == "") {
      seterror("Please enter confirm password")
      setTimeout(() => {
        seterror(null)
      }, 5000);
      return
    }

    if (passwordDetails.newPassword != passwordDetails.confirmPassword) {
      seterror("New password and confirm password does not match")
      setTimeout(() => {
        seterror(null)
      }, 5000);
      return
    }

    if (!password_pattern.test(passwordDetails.newPassword)) {
      seterror(passwordPolicyDescription)
      setTimeout(() => {
        seterror(null)
      }, 10000);
      return
    }

    const updateResponse = await UpdatePersonalPassword({
      CurrentPassword: passwordDetails.currentPassword,
      NewPassword: passwordDetails.newPassword,
      UserID: JSON.parse(localStorage.getItem("authUser"))[2]
    })

    if (updateResponse.isSuccess) {
      setsuccess(updateResponse.data)
      setTimeout(() => {
        setsuccess(null)
      }, 5000);
      setPasswordDetails({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      })
    } else {
      seterror(updateResponse.data)
      setTimeout(() => {
        seterror(null)
      }, 5000);
    }

  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Profile</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="User" breadcrumbItem="Profile" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Media>
                    <div className="ms-3">
                      <img
                        src={isUserImage ? usrImg : avatar2}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <Media body className="align-self-center mx-3">
                      <div className="text-muted">
                        <h5>{username}</h5>
                        <p className="mb-1">{location}</p>
                      </div>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <Card>
                <CardBody>
                  <AvForm
                    className="form-horizontal"
                  >
                    <Row>
                      <h4 className="card-title mb-4">Change Personal Details</h4>
                    </Row>
                    <Row>
                      <Col md="12">

                        <DPTextBox
                          name="firstName"
                          labelText="First Name"
                          value={personalDetails.firstName}
                          className="form-control mb-3"
                          placeholder="Enter First Name"
                          textType="text"
                          maxLength="50"
                          required
                          onChange={personalDetailsOnChange}
                          disabled={!personalDetails.allowEdit}
                        />

                        <DPTextBox
                          name="lastName"
                          labelText="Last Name"
                          value={personalDetails.lastName}
                          className="form-control mb-3"
                          placeholder="Enter Last Name"
                          textType="text"
                          maxLength="50"
                          onChange={personalDetailsOnChange}
                          disabled={!personalDetails.allowEdit}
                        />

                        <DPTextBox
                          name="fullName"
                          labelText="Full Name"
                          value={personalDetails.fullName}
                          className="form-control mb-3"
                          placeholder="Enter Full Name"
                          textType="text"
                          maxLength="200"
                          onChange={personalDetailsOnChange}
                          disabled={!personalDetails.allowEdit}
                        />

                        <div className="text-center mt-4">
                          {!personalDetails.allowEdit ?
                            <Button type="button" color="primary" onClick={() => setPersonalDetails({ ...personalDetails, allowEdit: true })}>
                              Edit Details
                            </Button>
                            :
                            <div>
                              <Button type="submit" color="success" onClick={handleValidSubmit}>
                                Update Details
                              </Button>
                              <Button type="button" color="danger" className="mx-2" onClick={() => setPersonalDetails({ ...personalDetails, allowEdit: false })}>
                                Cancel
                              </Button>
                            </div>
                          }
                        </div>

                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
            <Col md="6">
              <Card>
                <CardBody>
                  <AvForm
                    className="form-horizontal">
                    <Row>
                      <h4 className="card-title mb-4">Change Your Password</h4>
                    </Row>
                    <Row>
                      <Col md="12">

                        <DPTextBox
                          name="currentPassword"
                          labelText="Current Password"
                          value={passwordDetails.currentPassword}
                          className="form-control mb-3"
                          placeholder="Enter Current Password"
                          textType="password"
                          maxLength="15"
                          onChange={passwordDetailsOnChange}
                          
                        />

                        <DPTextBox
                          name="newPassword"
                          labelText="New Password"
                          value={passwordDetails.newPassword}
                          className="form-control mb-3"
                          placeholder="Enter New Password"
                          textType="password"
                          maxLength="15"
                          onChange={passwordDetailsOnChange}
                        />

                        <DPTextBox
                          name="confirmPassword"
                          labelText="Confirm Password"
                          value={passwordDetails.confirmPassword}
                          className="form-control mb-3"
                          placeholder="Enter Confirm Password"
                          textType="password"
                          maxLength="15"
                          onChange={passwordDetailsOnChange}
                        />

                        <div className="text-center mt-4">
                          <Button type="submit" color="success" onClick={handleUpdatePassword}>
                            Update Password
                          </Button>
                        </div>

                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
